import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireSuperadmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-background text-muted-foreground"
      >
        <div className="flex items-center gap-3">
          <div className="h-2 w-2 rounded-full bg-primary animate-pulse" />
          <span className="text-sm tracking-wide uppercase">Loading</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (requireSuperadmin && user.role !== "superadmin") {
    return (
      <div
        data-testid="forbidden-page"
        className="min-h-screen flex items-center justify-center bg-background text-foreground p-6"
      >
        <div className="max-w-md text-center space-y-3">
          <div className="font-display text-5xl gold-text">403</div>
          <h1 className="text-2xl font-display">Restricted area</h1>
          <p className="text-muted-foreground">
            This section is only available to the superadmin.
          </p>
          <a
            href="/admin"
            className="inline-block mt-4 px-5 py-2 rounded-full border border-primary/40 text-primary hover:bg-primary/10 transition"
            data-testid="forbidden-back-link"
          >
            Back to dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
}
